import { QuickLinkFormValues } from "../components/QuickLinkForm/QuickLinkForm";

export function formValuesToQuickLink(
	data: QuickLinkFormValues,
	id?: number
): Partial<QuickLink> & { audienceGroupIds?: number[] } {
	const hasFeed = Boolean(data.feedId);
	return {
		...(id !== undefined && { id }),
		heading: data.heading,
		content: data.content || null,
		buttonLink: hasFeed ? null : data.buttonLink || null,
		webview: hasFeed ? false : data.buttonLink ? data.webview : false,
		feedId: data.feedId,
		modalLink: null,
		audienceGroupIds: data.audienceGroupIds ?? []
	};
}
